import { Flex } from 'antd';
import { useMemo } from 'react';
import { getGrafanaEmbedURL } from '@Features/DashboardWidgets/utils/getGrafanaEmbedUrl';
import { currentToken } from '@Store/selectors/authSelector';
import { useAppSelector } from '@Hooks/index';
import commonStyle from '../../common-mobile-styles.module.css';
import styles from './component-styles.module.css';

const TodaySummaryMobile: React.FC = () => {
  const authToken = useAppSelector(currentToken);
  const grafanaURL = useMemo(
    // Grafana mobile widget has id = 2
    () => getGrafanaEmbedURL('2', authToken),
    [authToken]
  );

  return (
    <Flex vertical>
      <div className={commonStyle.caption}>Today&apos;s Summary</div>
      <div className={styles.summaryContent}>
        <iframe
          src={grafanaURL}
          className={commonStyle.iframe}
          title="Today Summary Mobile"
        />
      </div>
    </Flex>
  );
};

export default TodaySummaryMobile;
